import { padStart } from 'lodash';
import proxyHttpRequest from "services/proxy-http-request";

const getLocationInfo = async (lat, lon) => {
  const url = `https://www.weatheri.co.kr/wtiapp/index.php?kind=3&LON=${lon}&LAT=${lat}`;

  const response = await proxyHttpRequest.request(url);

  return response;
}

const getWeatherNow = async (regionCode) => {
  const url = `https://www.weatheri.co.kr/wtiapp/data/now_${regionCode}.xml`;

  const response = await proxyHttpRequest.request(url);

  return response;
}

const getWeatherForecastThree = async (regionCode) => {
  const url = `https://www.weatheri.co.kr/wtiapp/data/fctthree_${regionCode}.xml`;

  const response = await proxyHttpRequest.request(url);

  return response;
}

const getWeatherForecastToday = async (regionCode) => {
  const url = `https://www.weatheri.co.kr/wtiapp/data/fctday_${regionCode}.xml`;

  const response = await proxyHttpRequest.request(url);

  return response;
}

const getWeatherRadar = async (regionCode) => {
  const url = `https://www.weatheri.co.kr/wtiapp/data/rdr.xml`;

  const response = await proxyHttpRequest.request(url);

  return response;
}

const getWeatherSatellite = async (regionCode) => {
  const url = `https://www.weatheri.co.kr/wtiapp/data/sat.xml`;

  const response = await proxyHttpRequest.request(url);

  return response;
}

const getWeatherBackgroundName = (weatherCode, isNight) => {
  let weatherBackgroundName = '';
  
  switch (weatherCode) {
    case '1':
        weatherBackgroundName = isNight ? padStart('8', 2, '0') : padStart('1', 2, '0');
        break;
    case '2':
        weatherBackgroundName = isNight ? padStart('9', 2, '0') : padStart('2', 2, '0');
        break;
    case '21':
        weatherBackgroundName = isNight ? padStart('10', 2, '0') : padStart('3', 2, '0');
        break;
    case '22':
        weatherBackgroundName = padStart('7', 2, '0');
        break;
    case '4':
    case '7':
    case '10':
    case '17':
    case '18':
        weatherBackgroundName = isNight ? padStart('12', 2, '0') : padStart('5', 2, '0');
        break;
    case '5':
    case '6':
    case '8':
    case '19':
    case '20':
        weatherBackgroundName = isNight ? padStart('13', 2, '0') : padStart('6', 2, '0');
        break;
    default:
        weatherBackgroundName = isNight ? padStart('11', 2, '0') : padStart('4', 2, '0');
        break;
  }

  return `bg${weatherBackgroundName}`;
}

const getWeatherBackgroundColor = (weatherCode, isNight) => {
  let weatherBackgroundColor = isNight ? '#354870' : '#2D87ED';
  
  switch (weatherCode) {
    case '1':
        weatherBackgroundColor = isNight ? '#34466E' : '#2E90EF';
        break;
    case '2':
        weatherBackgroundColor = isNight ? '#3B4D76' : '#3193EE';
        break;
    case '21':
        weatherBackgroundColor = isNight ? '#354870' : '#2D87ED';
        break;
    case '22':
        weatherBackgroundColor = '#7D7570';
        break;
    case '4':
    case '7':
    case '10':
    case '17':
    case '18':
        weatherBackgroundColor = isNight ? '#4E5058' : '#676B6E';
        break;
    case '5':
    case '6':
    case '8':
    case '19':
    case '20':
        weatherBackgroundColor = isNight ? '#3D5061' : '#4D647C';
        break;
    default:
        weatherBackgroundColor = isNight ? '#443F5B' : '#535165';
        break;
  }

  return weatherBackgroundColor;
}

const getWindDirectionName = (direction) => {
  if (direction) {
    switch (direction.toLowerCase()) {
      case 'n':
        return '북';
      case 'ne':
        return '북동';
      case 'e':
        return '동';
      case 'se':
        return '남동';
      case 's':
        return '남';
      case 'sw':
        return '남서';
      case 'w':
        return '서';
      case 'nw':
        return '북서';
      default:
        return '';
    }
  }

  return '';
}

export default {
  getLocationInfo,
  getWeatherNow,
  getWeatherForecastThree,
  getWeatherForecastToday,
  getWeatherRadar,
  getWeatherSatellite,
  getWeatherBackgroundName,
  getWindDirectionName,
  getWeatherBackgroundColor
}